import React from "react";
import { EyeOff } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

// POST an ignore and show a toast with an Undo action. Resolves with the
// saved ignore doc so callers can prune the row locally.
export async function ignoreItem(body, { label, onUndo }) {
  const { data } = await api.post(`/cleanup/ignores`, body);
  toast.success(`Ignored ${label}`, {
    description: "Hidden from future audits until the data changes.",
    duration: 6000,
    action: {
      label: "Undo",
      onClick: async () => {
        try {
          await api.delete(`/cleanup/ignores/${data.id}`);
          toast.success(`Restored ${label}`);
          onUndo?.();
        } catch (e) {
          toast.error(e.response?.data?.detail || "Undo failed");
        }
      },
    },
  });
  return data;
}

export function IgnoreButton({ onClick, disabled, testId, className = "" }) {
  return (
    <Button
      type="button"
      size="sm"
      variant="ghost"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClick(); }}
      disabled={disabled}
      className={`text-slate-500 hover:text-slate-900 shrink-0 ${className}`}
      title="Ignore — hide this result from future audits"
      data-testid={testId}
    >
      <EyeOff className="h-4 w-4 mr-1.5" /> Ignore
    </Button>
  );
}
